import React from 'react';
import { Container, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import TitleMessage from './TitleMessage';
import Button from '@/components/Button/Button';
const useStyles = makeStyles((theme) => ({
  root: {},
  container: {
    paddingLeft: '0',
    fontFamily: 'OpenSans',
    lineHeight: '20px',
    minHeight: 'calc(100vh - 415px)',
    '@media (min-width: 1320px)': {
      maxWidth: '1600px',
    },
  },
  mtSection: {
    marginTop: '56px',
    '@media (max-width: 992px)': {
      marginTop: '40px',
    },
  },
  containerPadding: {
    display: 'flex',
    flexWrap: 'wrap',
    paddingLeft: 0,
    // '@media (max-width: 599px)': {
    //   paddingLeft: '8px',
    // },
    // '@media (min-width: 600px) and (max-width: 992px)': {
    //   paddingLeft: '16px',
    // },
    '@media (min-width: 1320px)': {
      maxWidth: '1600px',
    },
  },
  title: {
    width: '318px',
    height: 'fit-content',
    flexGrow: '0',
    flexShrink: '0',
    marginRight: '24px',
    marginBottom: '24px',
  },
  card: {
    marginBottom: '24px',
    width: '888px',
    height: 'fit-content',
    flexGrow: '0',
    flexShrink: '0',
    '@media (max-width: 480px)': {
      width: '100%',
    },
    borderRadius: '8px',
    boxShadow: '0px 2px 10px 1px rgb(0 0 0 / 12%)',
    background: theme.palette.$lightWhite,
  },
  cardHeader: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    height: '160px',
  },
  image: {
    width: '280px',
    height: '160px',
    borderRadius: '8px',
  },
  desContainer: {
    width: '588px',
    margin: '0 24px 40px 24px',
  },
  bigTip: {
    width: '588px',
    padding: '66px 0 24px 24px',
    verticalAlign: 'middle',
    fontWeight: 'bold',
    alignItems: 'baseline',
    fontSize: theme.typography.$fzH2,
    lineHeight: theme.typography.$lhH2,
    color: theme.palette.$dark100,
    whiteSpace: 'pre-line',
    letterSpacing: 0,
  },
  smallTip: {
    width: '660px',
    letterSpacing: 0,
    fontSize: theme.typography.$fzH4,
    lineHeight: theme.typography.$lhH4,
    color: theme.palette.$dark50,
    lineHeight: '22px'
  },
  successBlock: {
    marginLeft: '24px',
    marginRight: '24px',
  },
  hide: {
    display: 'none',
  },
  leftButton: {
    marginRight: '24px',
    '@media (max-width: 992px)': {
      marginRight: '16px',
      marginBottom: '24px',
    },
  },
  mt2: {
    marginTop: '2px'
  },
  ptSuccess: {
    paddingTop: '94px'
  }
}), 'set-up-access-status');

const Status = ({ data={} }) => {
  const classes = useStyles();

  return (
    <Container className={clsx(classes.container, classes.mtSection)}>
            <Container className={classes.containerPadding}>
              <div className={classes.title}>
                <TitleMessage titleName="COMPLETE APPLICATION" />
              </div>
              <div className={classes.card}>
                <div className={classes.cardHeader}>
                  <div className={clsx(classes.bigTip, data.pt ? classes[data.pt] : '')}>{data.title}</div>
                  <img className={classes.image} src={data.logo} alt="" />
                </div>
                <div className={classes.desContainer}>
                  <div className={classes.smallTip}>
                    <p>{data.desc}</p>
                  </div>
                </div>
                {data.btnText && (
                  <div className={classes.leftButton}>
                    <Button
                      backgroundClass="bgGunmetalBluegrey" style={{
                        fontWeight: '600', fontSize: '18px', lineHeight: '24px', letterSpacing: '1px', margin: '0 0 24px 24px',
                      }} onClick={data.clickAction}
                    >
                      {data.btnText}
                    </Button>
                  </div>
                )}
              </div>
            </Container>
          </Container>
  );
};

export default Status;
